// import React from 'react';
// import OlderMen from "../../Assets/images/affiliator_and_tenderpublish/Asset 24.png";
// import RecyclePic from "../../Assets/images/affiliator_and_tenderpublish/Asset 23.png";

// const TenderPublish = () => {
//   return (
//     <div className="container mx-auto bg-white mt-40 pt-60 px-4">
//       {/* Header */}
//       <h1 className="text-2xl font-bold text-center md:text-6xl">
//         Tender Publishing <br />{" "}
//         <span className="text-yellow-600">Request steps</span>
//       </h1>

//       {/* Container for Images */}
//       <div className="flex flex-row md:flex-row gap-4 items-center justify-center mt-8">
//         {/* First Image */}
//         <img
//           src={RecyclePic}
//           alt="Recycle Pic"
//           className="w-full max-w-xs md:max-w-md lg:max-w-lg h-auto rounded-lg"
//         />

//         {/* Second Image */}
//         <img
//           src={OlderMen}
//           alt="Older Men"
//           className="w-full max-w-xs md:max-w-md lg:max-w-lg h-auto rounded-lg"
//         />
//       </div>
//     </div>
//   );
// };

// export default TenderPublish;


import React from 'react';
import OlderMen from "../../Assets/images/affiliator_and_tenderpublish/Asset 24.png";
import RecyclePic from "../../Assets/images/affiliator_and_tenderpublish/Asset 23.png";

const TenderPublish = () => {
  return (
    <div className="">
      <div className="bg-gradient-to-r from-gray-100 via-white to-gray-300 px-4">
        {/* Header */}
        <h1 className="text-xl font-bold text-center md:text-2xl md:pt-6 pt-4">
          Tender Publishing {' '}
          <span className="text-ServiceIconColor">Request steps</span>
        </h1>
        {/* Container for Images */}
        <div className="flex flex-row gap-1 items-end justify-center">
          {/* First Image */}
          <img
            src={RecyclePic}
            alt="Recycle Pic"
            className="w-2/3  md:w-2/4 lg:w-2/3 h-auto rounded-lg mt-4"
          />

          {/* Second Image */}
          <img
            src={OlderMen}
            alt="Older Men"
            className="w-1/3  md:w-2/4 lg:w-1/3 h-auto rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};


const TenderPublishLandingPage = () => {
  return (
    <div className="bg-gradient-to-r  from-gray-100 via-white to-gray-300">
      <div className="container mx-auto px-4">
        {/* Header */}
        <h1 className="text-xl font-bold text-center md:text-2xl md:pt-6 pt-4">
          Tender Publishing {' '}
          <span className="text-ServiceIconColor">Request steps</span>
        </h1>
        {/* Container for Images */}
        <div className="flex flex-row gap-2 md:items-center lg:items-center items-end justify-center md:-mt-10 mt-10">
          {/* First Image */}
          <img
            src={RecyclePic}
            alt="Recycle Pic"
            className="w-2/3 sm:w-1/3 md:w-2/4 lg:w-2/5 xl:w-3/6 h-auto rounded-lg pb-3 md:pb-0 lg:pb-0"
          />

          {/* Second Image */}
          <img
            src={OlderMen}
            alt="Older Men"
            className="w-1/3 sm:w-1/3 md:w-2/4 lg:w-2/5 xl:w-3/6 h-auto rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default TenderPublish;

export { TenderPublishLandingPage };
